import Unitaire from '../views/FormulaireUnitaire/Unitaire'
import ActiviteReservee from '../components/Unitaires/ActiviteReservee'
import AutresAutorisationsDePratique from '../components/Unitaires/AutresAutorisationsDePratique'
import StatutEmploiEtLieuxDeTravail from '../components/Unitaires/StatutEmploiEtLieuxDeTravail'
import RenseignementsGeneraux from '../components/Unitaires/RenseignementsGeneraux'
import Imposition from '../components/imposition/imposition'
import TransmissionOrdre from "@/components/Unitaires/TransmissionOrdre.vue";

export default [{
  path: '/unitaire',
  component: Unitaire,
  meta: {
    title: 'Formulaire Unitaire | OTSTCFQ'
  },
  children: [
    {
      path: 'activite-reservee/:contactId',
      name: 'Unitaire/ActiviteReservee',
      component: ActiviteReservee,
      meta: {
        title: 'Formulaire Unitaire - Activité réservée | OTSTCFQ'
      },
    },
    {
      path: 'autres-autorisation-de-pratique/:contactId',
      name: 'Unitaire/AutresAutorisationsDePratique',
      component: AutresAutorisationsDePratique,
      meta: {
        title: 'Formulaire Unitaire - Autres autorisations de pratique | OTSTCFQ'
      }
    },
    {
      path: 'statut-emploi-et-lieux-de-travail/:contactId',
      name: 'Unitaire/StatutEmploiEtLieuxDeTravail',
      component: StatutEmploiEtLieuxDeTravail,
      meta: {
        title: 'Formulaire Unitaire - Statut d\'emploi et lieu(x) de travail | OTSTCFQ'
      },
    },
    {
      path: 'renseignements-generaux/:contactId',
      name: 'Unitaire/RenseignementsGeneraux',
      component: RenseignementsGeneraux,
      meta: {
        title: 'Formulaire Unitaire - Renseignements généraux | OTSTCFQ'
      },
    },
    {
      path: 'transmission-ordre/:contactId',
      name: 'Unitaire/TransmissionOrdre',
      component: TransmissionOrdre,
      meta: {
        title: 'Formulaire Unitaire - Transmission ordre | OTSTCFQ'
      }
    },
    {
      path: 'imposition/:contactId',
      name: 'Unitaire/Imposition',
      component: Imposition,
      meta: {
        title: 'Formulaire Unitaire - Imposition | OTSTCFQ'
      }
    },
  ]
}]